import React, { useEffect } from "react";

import useStore from "../store/useStore";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Navbar from "../components/navbar";

import BlogCard from "../components/BlogCard";
import HeroComexButton from "../components/HeroComexButton";

export default function Blog() {
  const { novedades, fetchNovedades, blogHeroes, getBlogHeroes } = useStore();

  useEffect(() => {
    fetchNovedades();
    getBlogHeroes();
  }, [fetchNovedades, getBlogHeroes]);

  console.log("BlogHeroes:", novedades);

  return (
    <>
      <header>
        <Navbar />
      </header>
      <main>
        <section>
          {blogHeroes && blogHeroes.length > 0
            ? blogHeroes.map((item, index) => (
                <HeroComexButton
                  key={index}
                  video={item.video?.[0]?.url}
                  titulo={item.titulo}
                  imagen={item.img?.[0]?.url}
                  height="h-[350px]"
                />
              ))
            : null}
        </section>
        <section className="relative md:py-24 py-16">
          <div className="container relative">
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
              {(novedades || []).map((item, index) => (
                <BlogCard
                  key={item.id || index}
                  id={item.id}
                  titulo={item.titulo}
                  image={
                    item.imagen && item.imagen[0] ? `${item.imagen[0].url}` : ""
                  }
                  data={""}
                  desc={
                    item.contenido && item.contenido[0]?.children
                      ? item.contenido[0].children[0]?.text?.slice(0, 120) +
                        "..."
                      : ""
                  }
                />
              ))}
            </div>
          </div>
        </section>
        <section className="relative md:py-24 py-16">
          <div className="container relative">
            <h3 className="font-extrabold text-left text-4xl md:text-5xl text-sidom-orange mb-[30px]">
              Favoritos
            </h3>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
              {(novedades || [])
                .filter((item) => item.tipo === "Favoritos")
                .map((item, index) => (
                  <BlogCard
                    key={item.id || index}
                    id={item.id}
                    titulo={item.titulo}
                    image={
                      item.imagen && item.imagen[0]
                        ? `${item.imagen[0].url}`
                        : ""
                    }
                    desc={
                      item.contenido && item.contenido[0]?.children
                        ? item.contenido[0].children[0]?.text?.slice(0, 120) +
                          "..."
                        : ""
                    }
                  />
                ))}
            </div>
          </div>
        </section>
      </main>
      <footer>
        <Footer />
      </footer>

      <Switcher />
    </>
  );
}
